/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

class AddressFromBillerButton extends React.Component {

    constructor(props, context){
        super(props, context);
        this.getAddressFromBiller = this.getAddressFromBiller.bind(this);
    }

    getAddressFromBiller(){
        const {workOrderActions, workOrderDetails, orderId} = this.props;
        const request = {
            billingSystem: workOrderDetails.getIn(['schedulingSystemDetails', 'details', 'billingSystem']),
            accountNumber: workOrderDetails.getIn(['customerDetails', 'details', 'accountNumber'])
        };
        workOrderActions.getAddressFromBillerStarted(request, orderId);
    }

    render() {

        const labelStyle = {
            fontSize: '11px',
            paddingLeft: '8px',
            paddingRight: '8px'                        
        };

        return (
            <RaisedButton
            fullWidth
            primary
            labelStyle={labelStyle}
            onTouchTap={this.getAddressFromBiller}
            label="Get Address From Biller"/>
        );
    }
}

AddressFromBillerButton.propTypes = {
    workOrderActions: PropTypes.object,
    workOrderDetails: PropTypes.object,
    orderId: PropTypes.string
};

export default AddressFromBillerButton;


// WEBPACK FOOTER //
// ./src/components/work-order/AddressFromBillerButton.js